export function getStockCountErrorMessage(error, fallback) {
  if (error?.code === "ERR_NETWORK" || error?.request) {
    return "No pudimos conectar con el servidor. Revisá tu conexión e intentá nuevamente.";
  }

  const status = Number(error?.response?.status || error?.status || 0);
  const message =
    error?.response?.data?.detail ||
    error?.response?.data?.message ||
    error?.data?.detail ||
    error?.data?.message ||
    error?.message;

  if (message) return Array.isArray(message) ? message.join(" · ") : message;

  if (status === 400) {
    return "Revisá los datos ingresados antes de continuar.";
  }
  if (status === 403) {
    return "No tenés permisos para realizar esta acción.";
  }

  return fallback;
}
